import {
  GetB2bFullyManagedPlanContributionsOneResponse,
  GetB2bOrderDetailsResponse,
} from '@Common/types/b2b/orders';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const orderSideChoices = makeChoicesCommon<GetB2bOrderDetailsResponse['side']>()({
  buy: 'resources.bo_common.b2b.orders.sides.buy',
  sell: 'resources.bo_common.b2b.orders.sides.sell',
});

export const b2bOrderOperationChoices = makeChoicesCommon<
  GetB2bOrderDetailsResponse['operation']
>()({
  subscription: 'resources.bo_common.b2b.orders.operation.subscription',
  arbitrage: 'resources.bo_common.b2b.orders.operation.arbitrage',
  redemption: 'resources.bo_common.b2b.orders.operation.redemption',
  liquidation: 'resources.bo_common.b2b.orders.operation.liquidation',
});

export const b2bOrderStatusChoices = makeChoicesCommon<GetB2bOrderDetailsResponse['status']>()({
  pending: 'resources.bo_common.b2b.orders.status.pending',
  filled: 'resources.bo_common.b2b.orders.status.filled',
  shares_canceled: 'resources.bo_common.b2b.orders.status.shares_canceled',
  shares_new: 'resources.bo_common.b2b.orders.status.shares_new',
  pending_funds: 'resources.bo_common.b2b.orders.status.pending_funds',
  shares_pending_arbitrage: 'resources.bo_common.b2b.orders.status.shares_pending_arbitrage',
  shares_pending_company: 'resources.bo_common.b2b.orders.status.shares_pending_company',
  shares_pending_campaign: 'resources.bo_common.b2b.orders.status.shares_pending_campaign',
  shares_pending_reallocation: 'resources.bo_common.b2b.orders.status.shares_pending_reallocation',
  shares_pending_approval: 'resources.bo_common.b2b.orders.status.shares_pending_approval',
  shares_pending_cutoff_period:
    'resources.bo_common.b2b.orders.status.shares_pending_cutoff_period',
  shares_pending_blocked_instrument:
    'resources.bo_common.b2b.orders.status.shares_pending_blocked_instrument',
  shares_pending_triggered_order:
    'resources.bo_common.b2b.orders.status.shares_pending_triggered_order',
  rejected: 'resources.bo_common.b2b.orders.status.rejected',
  shares_pending_scheduling: 'resources.bo_common.b2b.orders.status.shares_pending_scheduling',
});

export const b2bCancellationReasonChoices = makeChoicesCommon<
  Exclude<GetB2bOrderDetailsResponse['cancellation_reason'], null>
>()({
  error: 'resources.bo_common.b2b.orders.cancellation_reason.error',
  compliance_verification_failed:
    'resources.bo_common.b2b.orders.cancellation_reason.compliance_verification_failed',
  failed_deposit: 'resources.bo_common.b2b.orders.cancellation_reason.failed_deposit',
  insufficient_balance: 'resources.bo_common.b2b.orders.cancellation_reason.insufficient_balance',
  expired: 'resources.bo_common.b2b.orders.cancellation_reason.expired',
  skipped: 'resources.bo_common.b2b.orders.cancellation_reason.skipped',
  user_action: 'resources.bo_common.b2b.orders.cancellation_reason.user_action',
  order_not_tradable: 'resources.bo_common.b2b.orders.cancellation_reason.order_not_tradable',
  shares_agent: 'resources.bo_common.b2b.orders.cancellation_reason.shares_agent',
  sof_task_rejected: 'resources.bo_common.b2b.orders.cancellation_reason.sof_task_rejected',
});

export const b2bCancellationInitiatorChoices = makeChoicesCommon<
  Exclude<GetB2bOrderDetailsResponse['cancellation_initiator'], null>
>()({
  user: 'resources.bo_common.b2b.orders.cancellation_initiator.user',
  bo: 'resources.bo_common.b2b.orders.cancellation_initiator.bo',
  system: 'resources.bo_common.b2b.orders.cancellation_initiator.system',
});

export const b2bOrderOddoStatusChoices = makeChoicesCommon<
  Exclude<GetB2bOrderDetailsResponse['oddo_status'], null>
>()({
  sent: 'resources.bo_common.b2b.orders.oddo_status.sent',
  acknowledged: 'resources.bo_common.b2b.orders.oddo_status.acknowledged',
  confirmed: 'resources.bo_common.b2b.orders.oddo_status.confirmed',
  rejected: 'resources.bo_common.b2b.orders.oddo_status.rejected',
});

export const b2bFullyManagedPlanContributionsStatusChoices = makeChoicesCommon<
  GetB2bFullyManagedPlanContributionsOneResponse['status']
>()({
  pending: 'resources.bo_common.b2b.fully_managed_plan_contributions.status.pending',
  paid: 'resources.bo_common.b2b.fully_managed_plan_contributions.status.paid',
  shares_canceled:
    'resources.bo_common.b2b.fully_managed_plan_contributions.status.shares_canceled',
  funding_failed: 'resources.bo_common.b2b.fully_managed_plan_contributions.status.funding_failed',
});

export const b2bFullyManagedPlanContributionsTypeChoices = makeChoicesCommon<
  GetB2bFullyManagedPlanContributionsOneResponse['contribution_type']
>()({
  voluntary_deposit:
    'resources.bo_common.b2b.fully_managed_plan_contributions.type.voluntary_deposit',
  employer_matching_contribution:
    'resources.bo_common.b2b.fully_managed_plan_contributions.type.employer_matching_contribution',
  campaign_allocation:
    'resources.bo_common.b2b.fully_managed_plan_contributions.type.campaign_allocation',
  cross_plan_arbitrage:
    'resources.bo_common.b2b.fully_managed_plan_contributions.type.cross_plan_arbitrage',
});
